import React from "react";
import "./Popup2.scss";
import { useStoreActions, useStoreState } from "easy-peasy";
import Fade from "@material-ui/core/Fade";
import * as conf from "../../../config";

const Popup2 = () => {
  const popupPicture = useStoreState((state) => state.popup.picture);
  const setPicture = useStoreActions((actions) => actions.popup.setPicture);

  return (
    <Fade in={popupPicture != null} timeout={500}>
      <div onClick={() => setPicture(null)}>
        <div className="overlay"></div>
        {popupPicture && (
          <img
            className="popupInner2"
            src={conf.API_HOST + popupPicture}
            alt="popup picture"
          />
        )}
      </div>
    </Fade>
  );
};

export default Popup2;
